import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/ar/poi-layer/poi-layer.js';
      import {OverlapMode} from '@oicl/openbridge-webcomponents/dist/ar/poi-layer/poi-layer.js';

      export interface Props {
     label?: string;
     debug?: boolean;
     overlapMode?: OverlapMode;
     isSelected?: boolean;
     joinWhileExpanded?: boolean;
     internalSwapping?: boolean
   }

      
  
      export type {OverlapMode} from '@oicl/openbridge-webcomponents/dist/ar/poi-layer/poi-layer.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcPoiLayer',
  props: {
    label: {},
    debug: { type: Boolean },
    overlapMode: {},
    isSelected: { type: Boolean },
    joinWhileExpanded: { type: Boolean },
    internalSwapping: { type: Boolean }
  },
  emits: ["layer-resize"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onLayerResize: (event: CustomEvent<{height:number,label:string}>) => emit('layer-resize', event as CustomEvent<{height:number,label:string}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-poi-layer',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})